import React, { Fragment, useEffect, useState } from 'react'
import "./Header.css"
import bcc_logo from "../../assets/images/bcc_logo.png"
import { useNavigate } from 'react-router-dom'
import { CDN_BASE_URL } from '../../constants/constants'
import { getAppsConfig } from '../../services/http'


const Header = (props) => {

  const { bannerImg, title, telephone, email, institLabel, institPhone, institMail, logo } = props;
  const navigate = useNavigate();
  useEffect(() => {


    // When the user scrolls the page, execute myFunction
    window.onscroll = function () { myFunction() };

    // Get the header
    var header = document.getElementById("header-first-box");

    // Get the offset position of the navbar
    var sticky = header.offsetTop;

    // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
    function myFunction() {
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    }

  }, [document.getElementById("header-first-box")]);

  const [key, setKey] = useState('')
  const [appName, setAppName] = useState("Banque Centrale de Congo")
    const [appLogo, setAppLogo] = useState()
    const [appImage, setAppImage] = useState()

  const getAppliParams = async () => {
    let request = await getAppsConfig();
    if(request.response && request.response.status !== 200){
        console.log(request.response)
    } else {
        console.log("navbar app name ", request)
        setAppName(request.data.portail.portail_application_name)
        setAppLogo(request.data.portail.portail_favicon)
        setAppImage(request.data.portail.image)
    }
}
useEffect(() => {
getAppliParams();
}, [])

  return (
    <Fragment>
      <div id="header-first-box" className='header-first-box d-flex justify-content-between p-2'>
        <div className='header-logo-box d-flex' onClick={() => {
          navigate("/home")
          setKey('')
        }
          }>
          <img 
            // src={`${CDN_BASE_URL}${appLogo}`} 
            src={bcc_logo}
            className="header-logo" />
          <span className='bcc_name my-auto'>
            Banque Centrale
            {/* {appName} */}
          </span>
        </div>
        <div className='header-menu-box d-flex flex-wrap justify-content-around my-auto'>
          <div className={window.location.pathname === "/presentation" ? 'header-menu-item mx-2 active' : 'header-menu-item mx-2'} onClick={() => {
            navigate("/presentation")
            setKey('presentation')
          }
            }>Présentation</div>
          <div className={window.location.pathname === '/comparateur' ? 'header-menu-item mx-2 active' :'header-menu-item mx-2'} onClick={() => {
            navigate("/comparateur")
            setKey('comparateur')
          }
            }>Comparateur</div>
          <div className={window.location.pathname === '/simulateur' ? 'header-menu-item mx-2 active' : 'header-menu-item mx-2'} onClick={() => {
            navigate("/simulateur")
            setKey('simulateur')
          }
        }>Simulateur</div>
        </div>
      </div>
      <div className='header-second-box'
      //  style={{backgroundImage: `url(${bannerImg})`}}
      >

        {/* <h2 className="header-second-box-title my-auto pt-3">{title}</h2>
       <div className="header-second-box-title my-auto">{telephone}</div>
       <div className="header-second-box-title my-auto">{email}</div> */}

        <div class="bg-image"
        style={{backgroundImage: `url(${bannerImg})`}}
        ></div>

        <div class="bg-text d-flex">
          <div className='col-sm-6 col-xs-12 d-flex flex-wrap justify-content-end' style={{alignItems: 'center'}}>
           {logo && <img className='header-instit-logo text-right' src={`${CDN_BASE_URL}${logo}`} />}
          </div>
          <div className='col-sm-6 col-xs-12 d-flex justify-content-start' style={{alignItems: 'center'}} >
            <div>
              <h1 style={{ textAlign:'left', color: '#f9fafb' }}>{title}</h1>
              <h3 className='ta-left'>{telephone}</h3>
              <h3 className='ta-left'>{email}</h3>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default Header